module.exports = __webpack_public_path__ + "logo.png?abd39a4c2ae1f276c30efef5c0b31c1a";


//////////////////
// WEBPACK FOOTER
// ./dist/logo.png
// module id = 11
// module chunks = 0